import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import DeleteBtn from '../Base/DeleteBtn';
import SpaceConfigs from '../Base/SpaceConfigs';
import DuplicateBtn from '../Base/DuplicateBtn';

import { ISpace, ImageDisplayType, ImageSizingType } from '../../../../types/space';
import { ElementTypes } from '../../../../types/element';
import BackgroundConfigs from '../Base/BackgroundConfigs';
import BaseInputRadio from '../Base/InputRadio';
import BaseInputText from '../Base/InputText';
import { IRootState, IDispatch } from '../../../../modules/stores';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  space: ISpace<ElementTypes.FieldMultiAttachment>;
}

class EditFormFieldMultiAttachment extends React.PureComponent<IProps> {
  public render() {
    const {
      space,
      updateSpaceConfig,
      intl: { formatMessage },
    } = this.props;

    const IMAGE_DISPLAY_OPTIONS = [
      { name: formatMessage({ id: 'sidebar.image.display.first' }), value: ImageDisplayType.First },
      { name: formatMessage({ id: 'sidebar.image.display.all' }), value: ImageDisplayType.All },
    ];

    const IMAGE_SIZING_OPTIONS = [
      { name: formatMessage({ id: 'sidebar.image.sizing.fit' }), value: ImageSizingType.Fit },
      { name: formatMessage({ id: 'sidebar.image.sizing.fill' }), value: ImageSizingType.Fill },
      {
        name: formatMessage({ id: 'sidebar.image.sizing.stretch' }),
        value: ImageSizingType.Stretch,
      },
    ];

    return (
      <>
        <SpaceConfigs space={space} />
        <BaseInputRadio
          name="imageDisplay"
          setFn={(val: any) => {
            updateSpaceConfig({
              id: space.id,
              updates: { imageDisplay: val },
            });
          }}
          options={IMAGE_DISPLAY_OPTIONS}
          title={formatMessage({ id: 'sidebar.image.display' })}
          value={space.config.imageDisplay}
        />
        {space.config.imageDisplay === ImageDisplayType.First ? (
          <BaseInputRadio
            name="imageSizing"
            setFn={(val: any) => {
              updateSpaceConfig({
                id: space.id,
                updates: { imageSizing: val },
              });
            }}
            options={IMAGE_SIZING_OPTIONS}
            title={formatMessage({ id: 'sidebar.image.sizing' })}
            value={space.config.imageSizing}
          />
        ) : (
          <>
            <BaseInputText
              name="imageSize"
              setFn={(val: number) => {
                updateSpaceConfig({
                  id: space.id,
                  updates: { imageSize: Number(val) },
                });
              }}
              title={formatMessage({ id: 'sidebar.image.size' })}
              type="number"
              value={space.config.imageSize}
            />
            <BaseInputText
              name="imagePadding"
              setFn={(val: number) => {
                updateSpaceConfig({
                  id: space.id,
                  updates: { imagePadding: Number(val) },
                });
              }}
              title={formatMessage({ id: 'sidebar.image.padding' })}
              type="number"
              value={space.config.imagePadding}
            />
          </>
        )}
        <BackgroundConfigs space={space} />
        <DuplicateBtn spaceId={space.id} />
        <DeleteBtn />
      </>
    );
  }
}

const mapState = ({ space, core }: IRootState) => ({
  fieldById: core.fieldById,
  viewById: core.viewById,
  indexDepth: space.indexDepth,
});

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpaceConfig: (payload: any) => space.updateSpaceConfig(payload),
});

export default compose(
  injectIntl,
  connect(
    mapState,
    // @ts-ignore
    mapDispatch,
  ),
)(EditFormFieldMultiAttachment);
